

































































































































import SeletorDeLojasDoUsuario from '@/components/loja/SeletorDeLojasDoUsuario.vue'
import CampoDeItemDeVenda from '@/components/venda/CampoDeItemDeVenda.vue'
import { ConsultaPrecoDeProduto, Loja, Produto } from '@/models'
import { ItemDaVenda } from '@/models/venda/Venda'
import { formatarMoeda } from '@/shareds/formatadores'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { FindProdutoUseCase, FindUsuarioUseCase } from '@/usecases'
import Component from 'vue-class-component'
import { Ref, Vue } from 'vue-property-decorator'
import { DataOptions } from 'vuetify'
import vueTabulator from 'vue-tabulator'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { isFormitz, isIostec, isMarcatto, isSantaines, isTexcotton, isVestcasa } from '@/shareds/utils'

Vue.use(vueTabulator, { name: 'vue-tabulator' })

@Component({
	components: {
		SeletorDeLojasDoUsuario,
		CampoDeItemDeVenda,
	},
})
export default class TelaDeConsultaDePreco extends Vue {
	@Ref() form0!: HTMLFormElement
	@Ref() form1!: HTMLFormElement
	@Ref() table!: HTMLFormElement
	@Ref() readonly campoDeBusca!: CampoDeItemDeVenda

	formatarMoeda = formatarMoeda

	findProdutoUseCase = new FindProdutoUseCase()
	findUsuarioUseCase = new FindUsuarioUseCase()

	dadosDaConsulaDeEstoque: object[] = []
	loja: Loja | null = null
	carregando = false
	loading = false
	temSomenteUmaLojaVinculada = false
	consultaDePrecoDeProdutos: ConsultaPrecoDeProduto[] | null = null
	mostraConsultaDeProduto = false
	busca = ''
	totalRegistros = -1
	produtoBipado: Produto | null = null
	vestcasa = isVestcasa
	iostec = isIostec
	santaines = isSantaines
	texcotton = isTexcotton
	marcatto = isMarcatto
	formitz = isFormitz

	options = {
		data: this.dadosDaConsulaDeEstoque,
		height: '311px',
		movableColumns: true,
		layout: 'fitColumns',
		persistence: {
			sort: true,
			filter: true,
			columns: true,
		},
		persistenceID: 'examplePersitstance',
		placeholder: 'Sem dados para exibir',
		columns: this.colunasFormatadas,
	}

	tabs = this.mostrarEstoque ? ['Preços', 'Estoque'] : ['Preços']

	paginacao: DataOptions = {
		page: 0,
		itemsPerPage: 5,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}

	async created() {
		if (!this.usuario) return
		this.temSomenteUmaLojaVinculada = await this.findUsuarioUseCase.existeSomenteUmaLojaVinculadaComUsuario(
			this.usuario.id,
		)
		if (this.temSomenteUmaLojaVinculada) {
			const lojaVinculada = await this.findUsuarioUseCase.findById(
				this.usuario.id,
			)
			this.loja = lojaVinculada.lojas[0]
		}
	}

	get usuario() {
		return UserLoginStore.usuario
	}

	get tab() {
		if (!this.$route.query.t) return 0
		const index = this.tabs.findIndex(tab => tab === this.$route.query.t)
		return index !== -1 ? index : null
	}

	set tab(value: number | null) {
		const tab = typeof value === 'number' ? this.tabs[value] : undefined
		this.$router
			.push({
				name: this.$route.name as string,
				query: { t: !value ? undefined : tab },
			})
			.catch()
	}

	get nomeDaTabelaDePreco() {
		if (!this.consultaDePrecoDeProdutos) return []
		return this.consultaDePrecoDeProdutos
	}

	get colunas() {
		if (this.dadosDaConsulaDeEstoque.length > 0) {
			const filtros = Object.keys(this.dadosDaConsulaDeEstoque[0])
			return filtros
		}
		return []
	}

	get colunasFormatadas() {
		return this.colunas.map(coluna => {
			return {
				title: coluna,
				field: coluna,
			}
		})
	}

	get buscaUnica() {
		return this.vestcasa || this.santaines || this.texcotton || this.marcatto || this.formitz
	}

	get mostrarEstoque() {
		return UserLoginStore.permiteRegraDeNegocio('exibir-estoque-na-tela-de-consulta-de-preço')
	}

	focarBusca() {
		setTimeout(() => {
			this.campoDeBusca.focus()
		})
	}

	async consultarPrecoDoProduto(item: ItemDaVenda) {
		if (!this.loja) return
		try {
			this.produtoBipado = item.produto as Produto
			this.mostraConsultaDeProduto = true
			this.loading = true
			const consultaPreco = await this.findProdutoUseCase.findConsultaPrecoDeProduto(
				item.produto.id,
				this.loja.id,
			)
			const consultaEstoque = await this.findProdutoUseCase.findConsultaEstoqueDeProduto(
				item.produto.id,
				this.loja.id,
			)
			this.dadosDaConsulaDeEstoque = consultaEstoque

			this.consultaDePrecoDeProdutos = consultaPreco
			this.options = {
				data: this.dadosDaConsulaDeEstoque,
				height: '311px',
				movableColumns: true,
				layout: 'fitColumns',
				persistence: {
					sort: true,
					filter: true,
					columns: true,
				},
				persistenceID: 'examplePersitstance',
				placeholder: 'Sem dados para exibir',
				columns: this.colunasFormatadas,
			}
			this.loading = false
		} catch (e) {
			this.loading = false
			AlertModule.setError(e)
		}
	}
}
